import { Flex, Stack, Switch, Text } from '@mantine/core';
import type { TemplateWithoutSections } from 'src/data-capture/hooks/templates/useTemplates';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { TemplateCard } from './TemplateCard';

type Props = {
  templates: TemplateWithoutSections[];
  onSelectTemplate: (templateId: string) => void;
  onBack?: () => void;
  summarise?: boolean;
  onSummariseChange?: (value: boolean) => void;
  showSummariseToggle?: boolean;
};

export const TemplateSelection = ({
  templates,
  onSelectTemplate,
  onBack,
  summarise,
  onSummariseChange,
  showSummariseToggle,
}: Props) => {
  return (
    <Stack gap="xs">
      <Flex justify="space-between" align="center">
        <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="gray.10">
          Select template to generate a meeting note
        </Text>
        {onBack && (
          <Text
            size="textSm"
            fw={FONT_WEIGHTS.semibold}
            c="brand.6"
            style={{ cursor: 'pointer' }}
            onClick={onBack}
          >
            Back
          </Text>
        )}
      </Flex>
      {showSummariseToggle && (
        <Flex justify="space-between" align="center">
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
            Summarise meeting note
          </Text>
          <Switch
            checked={summarise ?? true}
            onChange={event => onSummariseChange?.(event.currentTarget.checked)}
          />
        </Flex>
      )}
      <Stack gap="xxs">
        {templates.map(template => (
          <TemplateCard
            key={template.id}
            template={template}
            onSelect={() => onSelectTemplate(template.id)}
          />
        ))}
      </Stack>
    </Stack>
  );
};
